<template>
  <div class="base-radio-button jm-d-flex jm-align-items-center jm-mb-2">
    <input
      class="jm-mr-2"
      v-bind="$attrs"
      type="radio"
      :checked="modelValue === value"
      :value="value"
      @change="$emit('update:modelValue', value)"
      data-test="radio-button"
      :id="id || label"
    />
    <label v-if="label" data-test="radio-label" :for="id || label">{{
      label
    }}</label>
  </div>
</template>

<script>
export default {
  name: 'BaseRadio',
  props: {
    label: {
      type: String,
      default: ''
    },
    modelValue: {
      type: [String, Boolean],
      default: ''
    },
    value: {
      type: [String, Boolean],
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
input {
  accent-color: $black;
}

label {
  font-family: $font-primary !important;
  font-weight: 400 !important;
}

.base-radio-button {
  box-sizing: border-box;
  padding: $spacing-2;
  border: $border-width-sm solid $border-color-input;
  border-radius: $border-radius-base;
}
</style>
